<div class="container" *ngIf="{
            maxResendAttemptsReached: maxResendAttemptsReached$ | async, 
            emailResendToken: emailResendToken$ | async,
            systemConfigs: systemConfigs$ | async } as data">
    <div [innerHtml]="'text.ActivationPageLinkInformation' | translate: { 'email': data.systemConfigs?.jobseeker.contactEmail } | safeHtml" >
    </div>
    <div *ngIf="!data.maxResendAttemptsReached && data.emailResendToken!==null">
        <span class="email" (click)="onResend(data.emailResendToken)">{{ 'label.ResendActivationEmail' | translate}}</span>
    </div>
    <div *ngIf="data.maxResendAttemptsReached">
        <div class="warning" [innerHtml]="('message.MaxNumberOfAttemptsReached' | translate) | safeHtml"></div>
    </div>
</div>